import { FiX } from "react-icons/fi";

const WishlistItemCard = ({ item, onAdd, onRemove }) => {
  return (
    <div className="border rounded-lg p-3 relative">

      <img
        src={item.image}
        alt={item.name}
        className="w-full aspect-[3/4] object-cover"
      />

      <h2 className="mt-3 font-medium">{item.name}</h2>
      <p className="font-semibold">₹{item.price}</p>

      {/* <button
        onClick={onAdd}
        className="mt-3 w-full bg-black text-white py-2 rounded-md"
      >
        Add To Bag
      </button> */}

      <button
        onClick={onRemove}
        className="absolute top-3 right-3 bg-white p-2 rounded-full shadow"
      >
        <FiX />
      </button>

    </div>
  );
};

export default WishlistItemCard;